import { useState } from 'react';

import { Box, Panel, Stack, Text } from 'shell/components';

const options1 = [
    { key: 'edit-profile', value: 'Edit Profile', content: <Box>Panel 1 Content</Box>, disabled: false },
    { key: 'change-password', value: 'Change Password', content: <Box>Panel 2 Content</Box>, disabled: true },
    { key: 'team-details', value: 'Team Details', content: <Box>Panel 3 Content</Box> },
    { key: 'roles-&-permissions', value: 'Roles & Permissions', content: <Box>Panel 4 Content</Box> },
    { key: 'notification-preferences', value: 'Notification Preferences', content: <Box>Panel 5 Content</Box> },
];

const options2 = [
    { key: 'ensi100', value: 'ENSI 100', content: <Box>Panel 1 Content</Box>, term: 'Fall 2022' },
    { key: 'ensi101', value: 'ENSI 101', content: <Box>Panel 2 Content</Box>, term: 'Spring 2023' },
];

const PanelDemo = () => {
    const [panel1, setPanel1] = useState(options1[0].key);
    const [panel2, setPanel2] = useState(options2[0].key);

    return (
        <>
            <Text variant={'sh1'}>Panel</Text>
            <Panel label={'Profile & Settings'} options={options1} selected={panel1} onChange={setPanel1} />
            <Panel
                label={'Courses'}
                options={options2}
                renderTab={(option) => {
                    return (
                        <Stack sx={{ p: 2 }} alignItems={'flex-start'} spacing={2}>
                            <Text variant={'h6'} weight={'semibold'}>
                                {option.value}
                            </Text>
                            <Text color={'light'} variant={'p2'}>
                                {option.term}
                            </Text>
                        </Stack>
                    );
                }}
                selected={panel2}
                onAdd={console.log}
                onChange={setPanel2}
            />
        </>
    );
};

export default PanelDemo;
